import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { checkedProjects } from "../../features/api/Projects/projectsSlice";

export default function Projects({ project }) {
  const dispatch = useDispatch();
  const { projectName, colorClass } = project || {};

  const [check, setCheck] = useState(true);

  const handleChecked = () => {
    setCheck(!check);

    dispatch(checkedProjects({ project, checked: !check }));
  };

  return (
    <div className="mt-3 space-y-4">
      <div className="checkbox-container">
        <input
          type="checkbox"
          className={`${colorClass}`}
          checked={check}
          onChange={handleChecked}
        />
        <p className="label">{projectName}</p>
      </div>
    </div>
  );
}
